module.exports = "./img/7c830b562cc56342646ff7afa404176e.png";